<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
          <div>
            <h2 class="text-white font-weight-bold mb-1">{{ $t('quests.createCompensation') }}</h2>
            <p class="text-muted small mb-0">{{ $t('quests.compensationsSubtitle') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 grid-margin">
      <div class="card border border-secondary">
        <div class="card-body">
          <!-- Quick Presets -->
          <div class="rounded mb-4 p-3 d-flex align-items-center justify-content-between flex-wrap gap-2" style="background: rgba(30, 41, 59, 0.4); border: 1px solid #27272a;">
            <div class="d-flex align-items-center mb-2 mb-md-0">
              <i class="mdi mdi-lightning-bolt text-info font-weight-bold mr-2" style="font-size: 1.25rem;"></i>
              <div>
                <div class="text-white font-weight-bold small">{{ $currentLocale === 'id' ? 'Templat Penebusan Cepat' : 'Quick Compensation Presets' }}</div>
                <div class="text-muted small">{{ $currentLocale === 'id' ? 'Pilih templat tugas positif untuk menebus pelanggaran atau sanksi' : 'Select a positive remedial mission template to offset violations' }}</div>
              </div>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <button type="button" @click="applyPreset('sharing')" class="btn btn-xs btn-outline-info mr-1 mb-1">
                <i class="mdi mdi-presentation mr-1"></i> {{ $currentLocale === 'id' ? 'Sesi Berbagi 15 Menit' : '15-Min Sharing Session' }}
              </button>
              <button type="button" @click="applyPreset('review')" class="btn btn-xs btn-outline-success mr-1 mb-1">
                <i class="mdi mdi-code-tags-check mr-1"></i> {{ $currentLocale === 'id' ? 'Tinjauan Kode & Refaktor 3 Modul' : 'Code Review & Refactor 3 Modules' }}
              </button>
              <button type="button" @click="applyPreset('sop')" class="btn btn-xs btn-outline-primary mb-1">
                <i class="mdi mdi-file-document-edit-outline mr-1"></i> {{ $currentLocale === 'id' ? 'Dokumentasi SOP Baru' : 'New SOP Documentation' }}
              </button>
            </div>
          </div>

          <form class="forms-sample" method="post" @submit.prevent="submitForm">
            <div class="form-group row">
              <div class="col-md-6 mb-3">
                <label for="nameInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('rulesForm.compensationName') }}</label>
                <input
                  id="nameInput"
                  type="text"
                  class="form-control"
                  v-model="ruleStore.name"
                  :placeholder="$currentLocale === 'id' ? 'Contoh: Sesi Berbagi Pengetahuan 10 Menit' : 'e.g. 10-Minute Knowledge Sharing Session'"
                  required
                />
              </div>
              <div class="col-md-6 mb-3">
                <label for="descriptionInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('rulesForm.compensationDesc') }}</label>
                <textarea
                  id="descriptionInput"
                  class="form-control"
                  rows="3"
                  v-model="ruleStore.description"
                  :placeholder="$currentLocale === 'id' ? 'Jelaskan detail tugas sosial atau penebusan ini...' : 'Describe the remedial task requirements and proof standard...'"
                ></textarea>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2">
              <button type="button" @click="back" class="btn btn-outline-secondary px-4 py-2 mr-2" :disabled="loading">
                {{ $t('common.back') }}
              </button>
              <button type="submit" class="btn btn-primary px-4 py-2 font-weight-bold" :disabled="loading">
                <span class="spinner-border spinner-border-sm mr-1" v-if="loading" role="status"></span>
                <i class="mdi mdi-check-all mr-1" v-else></i>
                {{ $t('common.submit') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { storeCompensation } from '../../services/compensationService';
import Swal from 'sweetalert2';

export default {
  name: 'CreateCompensation',
  data: () => ({
    ruleStore: {
      name: '',
      description: '',
    },
    loading: false,
  }),
  methods: {
    back() {
      this.$router.go(-1);
    },
    applyPreset(type) {
      const isEn = this.$currentLocale === 'en';
      const presets = isEn ? {
        sharing: {
          name: '15-Minute Knowledge Sharing Session',
          description: 'Prepare materials and present a technical topic or best practice for 15 minutes to teammates.',
        },
        review: {
          name: 'Code Review & Refactor 3 Modules',
          description: 'Assist teammates by reviewing Pull Requests and refactoring code across at least 3 files or work modules.',
        },
        sop: {
          name: 'Create / Update Team SOP Documentation',
          description: 'Write or update workflow guides (SOP), API documentation, or team onboarding guides in the workspace documentation.',
        },
      } : {
        sharing: {
          name: 'Sesi Berbagi Pengetahuan 15 Menit',
          description: 'Mempersiapkan materi dan mempresentasikan topik teknis atau praktik terbaik selama 15 menit kepada rekan satu tim.',
        },
        review: {
          name: 'Peninjauan & Perapihan 3 Modul Kerja',
          description: 'Membantu meninjau pekerjaan rekan satu tim dan melakukan perapihan kode atau dokumen minimal pada 3 berkas atau modul kerja.',
        },
        sop: {
          name: 'Pembuatan / Pembaruan Dokumentasi SOP Tim',
          description: 'Menulis atau memperbarui panduan alur kerja (SOP), dokumentasi sistem, atau panduan orientasi tim di pusat dokumentasi.',
        },
      };

      const preset = presets[type];
      if (preset) {
        this.ruleStore.name = preset.name;
        this.ruleStore.description = preset.description;
      }
    },
    async submitForm() {
      this.loading = true;
      try {
        await storeCompensation(this.ruleStore);
        Swal.fire({
          title: this.$t('common.success'),
          text: this.$t('rulesForm.savedSuccess'),
          icon: 'success',
        });
        this.$router.push('/rules/compensations');
      } catch (error) {
        console.error('Error creating compensation:', error);
        Swal.fire({
          title: this.$t('common.error'),
          text: this.$currentLocale === 'id' ? 'Gagal menyimpan tugas kompensasi.' : 'Failed to create compensation task.',
          icon: 'error',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
